import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./pages/DashBoardMenu/HeaderComponent/Header";
import SideBarMenuDashboard from "./pages/SideBarMenu/SideBarMenuDashbaord";
import DashboardMainContent from "./pages/DashBoardMenu/DashBoardMainContent";
import ApiAccount from "./pages/APIAccountPage/ApiAccount/ApiAccount";
import CommissionMaster from "./pages/APIAccountPage/CommissionMaster/CommissionMaster";
import Wallet_balance_management from "./pages/APIAccountPage/WalletBalManagement/Wallet_balance_management";
import IdfcVanConfig from "./pages/ManageCollectionsMenu/IdfcVanConfig/IdfcVanConfig";
import IdfcVanReport from "./pages/ManageCollectionsMenu/IdfcVanReport/IdfcVanReport";
import PayoutReport from "./pages/ReportMenu/PayoutReport";
import ApiUserKyc from "./pages/APIAccountPage/UploadKYC/ApiUserKyc";
import ApiApproveKyc from "./pages/APIAccountPage/ApproveKYC/ApiApproveKyc";
import ActionForApprove from "./pages/APIAccountPage/ApproveKYC/ActionForApprove";
import ActiveServiceReport from "./pages/ServicesMenu/ActiveServiceReport/ActiveServiceReport";
import AddService from "./pages/ServicesMenu/AddService/AddService";
import ActivateService from "./pages/ServicesMenu/ActivateService/ActivateService";
import AdminLogin from "./pages/LoginPage/AdminLogin.jsx";
import ManagePermission from "./pages/APIAccountPage/ManagePermission/ManagePermission.jsx";
import PrivateRoute from "./pages/Components/PrivateRoute.js";
import CustomerReport from "./pages/ReportMenu/CustomerReport.jsx";
import ApiKeyReport from "./pages/ReportMenu/ApiKeyReport.jsx";
import NotFound from "./pages/ReportMenu/NotFound.jsx";
import FundManagementReport from "./pages/APIAccountPage/WalletBalManagement/FundManagementReport.jsx";
import PartnerShip from "./pages/PartnerShipMenu/PartnerShip.jsx";
import FundApprove from "./pages/APIAccountPage/ApproveFund/ApproveFund.jsx";
import ProviderReport from "./pages/ManageCollectionsMenu/ProvidersReport/ProvidersReport.jsx";
import LeadReport from "./pages/PartnerShipMenu/LeadReport/LeadReport.jsx";
import MasterTraining from "./pages/MasterTraining/MasterTraining.jsx";
import RouteList from "./pages/RoutesMenu/RouteList.jsx";
import MasterPage from "./pages/MasterPageMenu/MasterPage.jsx";
import News from "./pages/NewsMenu/News.jsx";
import Banner from "./pages/LoginBanner/Banner.jsx";
import ProductList from "./pages/ProductListMenu/ProductList.jsx";
import ProductNews from "./pages/ProductNews/ProductNews.jsx";
import Profile from "./pages/ProfileMenu/Profile.jsx";
import RegEmployee from "./pages/RegEmployee/RegEmployee.jsx";
import AssignedReport from "./pages/ReportMenu/AssignedReport.jsx";
import NetworkBackground from "./pages/LoginPage/NetworkBackground.jsx";
import SignUpReport from "./pages/ReportMenu/SignUpReport.jsx";
import ActivateServiceBulk from "./pages/ServicesMenu/ActivateServiceBulk/ActivateServiceBulk.jsx";
import DocumentMaster from "./pages/DocumentMaster/DocumentMaster.jsx";
import ApiServiceReport from "./pages/ReportMenu/ApiServiceReport.jsx";
import VendorMaster from "./pages/VendorMaster/VendorMaster.jsx";
import RegEmployeeReport from "./pages/RegEmployee/RegEmployeeReport.jsx";
import MobileDeviceLockReport from "./pages/MobileDeviceLockReport/MobileDeviceLockReport.jsx";
import ServiceUsageReport from "./pages/ReportMenu/ServiceUsageReport.jsx";
import RevenueReport from "./pages/ReportMenu/RevenueReport.jsx";
import ConsentMaster from "./pages/ConsentMessageMaster/ConsentMaster.jsx";
import GenerateMerchantToken from "./pages/GenerateMerchantToken.jsx";
import CheckPermissions from "./pages/RegEmployee/CheckPermissions.jsx";
import SendEmail from "./pages/BulkEmail/SendEmail.jsx";
import EmailConfiguration from "./pages/BulkEmail/EmailConfig.jsx";
import TemplateMaster from "./pages/BulkEmail/TemplateMaster.jsx";
import BillingMaster from "./pages/BillingMaster/BillingMaster.jsx";
import BankIFSCMaster from "./pages/IfscMaster/IfscMaster.jsx";
import ServiceList from "./pages/ReportMenu/ServiceList.jsx";
import DashboardLayout from "./pages/Components/layout/Layout.jsx";
import PartnerReport from "./pages/Partner/PartnerReport.jsx";
import GenerateQuotation from "./pages/APIAccountPage/GenerateQuotation/GenerateQuotation.jsx";
import CreatePartner from "./pages/Partner/CreatePartner.jsx";
import MandateReport from "./pages/MandateReport/MandateReport.jsx";
import BulkReport from "./pages/BulkService/BulkReport.jsx";
import SearchUserPage from "./pages/searchUser/SearchUser.jsx";
import GetUsersByServiceId from "./pages/searchUser/GetUsersByServiceId.jsx";
import FundManagementReportE from "./pages/APIAccountPage/WalletBalManagement/FundManagementReportE.jsx";
import TopServicesDashboard from "./pages/TopServices/TopServices.jsx";
import IDSPayQuotation from "./pages/APIAccountPage/GenerateQuotation/ApiQuotation/DownloadQuotation.jsx";
import DownloadSoftwareQuotation from "./pages/APIAccountPage/GenerateQuotation/SoftwareQuotation/DownloadSoftwareQuotation.jsx";

const AppContent = () => {
  const location = useLocation();

  const isLoginPage = location.pathname === "/";
  const isLoginPage2 = location.pathname === "*";

  return (
    <>
      <div className="min-h-screen w-full justify-start flex flex-col overflow-x-hidden">
        <div className="bg-gradient-to-r h-full from-indigo-900 to-blue-950 rounded-md shadow-lg flex-grow w-full">
          <ToastContainer />

          <Routes>
            {/* Public routes */}
            <Route path="/" element={<AdminLogin />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/QuotationPreview" element={<IDSPayQuotation />} />
            <Route path="/SoftwareQuotationPreview" element={<DownloadSoftwareQuotation />} />

            {/* Protected layout routes */}
            <Route
              element={
                <PrivateRoute>
                  <DashboardLayout />
                </PrivateRoute>
              }
            >
              {/* <Route path="/admin-dashboard" element={<DashboardMainContent />} />
        <Route path="/ActivateService" element={<ActivateService />} /> */}

              <Route
                path="/admin-dashboard"
                element={<DashboardMainContent />}
              />
              <Route path="/ActivateService" element={<ActivateService />} />
              <Route
                path="/ActivateServiceBulk"
                element={<ActivateServiceBulk />}
              />
              <Route
                path="/ActiveServiceReport"
                element={<ActiveServiceReport />}
              />
              <Route path="/AddService" element={<AddService />} />
              <Route path="/ActionForApprove" element={<ActionForApprove />} />
              <Route path="/IfscMaster" element={<BankIFSCMaster />} />
              <Route path="/DocumentMaster" element={<DocumentMaster />} />
              <Route path="/ConsentMaster" element={<ConsentMaster />} />
              <Route path="/ApiApproveKyc" element={<ApiApproveKyc />} />
              <Route path="/ApiUserKyc" element={<ApiUserKyc />} />
              <Route path="/PayoutReport" element={<PayoutReport />} />
              <Route path="/SignUpReport" element={<SignUpReport />} />
              <Route path="/CustomerReport" element={<CustomerReport />} />
              <Route path="/ApiKeyReport" element={<ApiKeyReport />} />
              <Route
                path="/ServiceUsageReport"
                element={<ServiceUsageReport />}
              />
              <Route path="/RevenueReport" element={<RevenueReport />} />
              <Route path="/wallet-transaction-reporte" element={<PrivateRoute><FundManagementReportE /></PrivateRoute>} />
              <Route path="/VendorMaster" element={<VendorMaster />} />
              <Route path="/ApiServiceReport" element={<ApiServiceReport />} />
              <Route path="/ServiceList" element={<ServiceList />} />
              <Route
                path="/MobileDeviceLockReport"
                element={<MobileDeviceLockReport />}
              />
              <Route path="/AssignedReport" element={<AssignedReport />} />
              <Route path="/IdfcVanConfig" element={<IdfcVanConfig />} />
              <Route path="/IdfcVanReport" element={<IdfcVanReport />} />
              <Route path="/ProvidersReport" element={<ProviderReport />} />
              <Route path="/ApiAccount" element={<ApiAccount />} />
              <Route path="/MasterPage" element={<MasterPage />} />
              <Route path="/News" element={<News />} />
              <Route path="/Banner" element={<Banner />} />
              <Route path="/ProductList" element={<ProductList />} />
              <Route path="/ProductNews" element={<ProductNews />} />
              <Route path="/PartnerShip" element={<PartnerShip />} />
              <Route path="/MasterTraining" element={<MasterTraining />} />
              <Route path="/RouteList" element={<RouteList />} />
              <Route path="/Profile" element={<Profile />} />
              <Route path="/LeadReport" element={<LeadReport />} />
              <Route
                path="/Wallet_balance_management"
                element={<Wallet_balance_management />}
              />
              <Route
                path="/wallet-transaction-report"
                element={<FundManagementReport />}
              />
              <Route path="/CommissionMaster" element={<CommissionMaster />} />
              <Route path="/ManagePermission" element={<ManagePermission />} />
              <Route path="/RegEmployee" element={<RegEmployee />} />
              <Route
                path="/RegEmployeeReport"
                element={<RegEmployeeReport />}
              />
              <Route
                path="/GenerateMerchantToken"
                element={<GenerateMerchantToken />}
              />
              <Route path="/SendEmail" element={<SendEmail />} />

              <Route path="/EmailConfig" element={<EmailConfiguration />} />

              <Route path="/TemplateMaster" element={<TemplateMaster />} />
              <Route path="/CheckPermissions" element={<CheckPermissions />} />

              <Route path="/FundApprove" element={<FundApprove />} />
              <Route path="/TopServices" element={<TopServicesDashboard />} />
              <Route path="/BillingMaster" element={<BillingMaster />} />
              <Route path="/SearchUser" element={<SearchUserPage />} />
              <Route path="/GetUsersByServiceId" element={<GetUsersByServiceId />} />
              <Route
                path="/GenerateQuotation"
                element={<GenerateQuotation />}
              />
              <Route path="/PartnerReport" element={<PartnerReport />} />
              <Route path="/MandateReport" element={<MandateReport />} />
              <Route path="/CreatePartner" element={<CreatePartner />} />
              <Route path="/BulkReport" element={<BulkReport />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
